// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__5Meex","dataSource":"Footer_dataSource__W94xf"};